import { render } from "./addForms.vue?vue&type=template&id=6660c283&scoped=true&ts=true"
import script from "./addForms.vue?vue&type=script&lang=ts"
export * from "./addForms.vue?vue&type=script&lang=ts"

import "./addForms.vue?vue&type=style&index=0&id=6660c283&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6660c283"]])

export default __exports__